export default "__VITE_ASSET__7d01d3d0__"